module.exports = __webpack_public_path__ + "static/media/hangman.dc5130d7.svg";